import { AgentFeature, isFeatureEnabledForLanguage } from '../agent-features'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { AssessGradeBadgeWithTooltip } from '../badge'
import React from 'react'
import { AgentLanguage } from '../agent-language'
import { GradeValue } from '../../graphql/schema/types/grade-value'
import { Placement } from '@popperjs/core'

interface Result {
  readonly applicationGrade: {
    readonly score: number
    readonly value: GradeValue
  }
}

interface Vars {
  readonly applicationID: string
  readonly organizationID: string
}

interface ApplicationGradeProps {
  readonly id: string
  readonly organizationID: string
  readonly features?: AgentFeature[]
  readonly language: AgentLanguage
  readonly tooltipPlacement?: Placement
}

export function ApplicationGrade({
  id,
  organizationID,
  features,
  language,
  tooltipPlacement
}: ApplicationGradeProps) {
  const isAssessSupported =
    features &&
    isFeatureEnabledForLanguage({
      language,
      agentFeatures: features,
      featureName: 'assess'
    })

  return (
    <Query<Result, Vars>
      query={gql`
        query GetApplicationGrade($organizationID: ID!, $applicationID: ID!) {
          applicationGrade(
            organizationID: $organizationID
            applicationID: $applicationID
          ) {
            value
            score
          }
        }
      `}
      variables={{
        applicationID: id,
        organizationID
      }}
    >
      {({ loading, data }) => {
        if (loading || !data) {
          return (
            <AssessGradeBadgeWithTooltip
              value="UNKNOWN"
              isAssessSupported={isAssessSupported}
            />
          )
        }

        const {
          applicationGrade: { value }
        } = data

        return (
          <AssessGradeBadgeWithTooltip
            value={value}
            isAssessSupported={isAssessSupported}
            tooltipPlacement={tooltipPlacement}
          />
        )
      }}
    </Query>
  )
}
